import React from 'react'
import NotificationList from 'srcReact/OrganizationPage/NotificationList'
import { useSelector } from 'react-redux'

const NotificationPageContainer = () => {
  const {
    common: { isNative },
  } = useSelector((state) => state)

  return <React.Fragment>{isNative && <NotificationList />}</React.Fragment>
}

export { NotificationPageContainer }
